<template>
  <Card pa-0>
    <Toolbar class="sub-header">
      <div class="mr-4 subheading">
        {{ $t(graphName) }}
      </div>
      <v-spacer></v-spacer>
      <div class="body-1">
        {{ showDate }}
      </div>
    </Toolbar>
    <v-container>
      <v-layout v-show="isLargeScreen" class="space">
        {{ $t('Total Inv Gen') }} :&nbsp; <span class="number--text">{{ totalInvGen }} kWh</span>
      </v-layout>
      <v-layout class="layout">
        <v-flex  v-show="isLargeScreen">
          <Select :items="blockList" :label="`Select Block `" :selection="blockList[0]" @change="blockDataHandler" offset-y outline class=" box-width" />
        </v-flex>
        <v-flex class="align-left">
          <Select :label="$t('Select Graph')" :items="graphCategoryList" :selection="graphCategory"
            :itemText="'text'" :itemValue="'value'" @change="graphChangeHandler" class="box-width"/>
        </v-flex>
        <v-flex xs6 lg6 class="hide-select">
          <Select v-if="showGraphType" :label="$t('Graph Type')"
            :items="graphTypeList" :selection="graphType"
            :itemText="'text'" :itemValue="'value'" 
            @change="(g) => graphType = g" class="box-width" pr-9/>
        </v-flex>
        <v-flex xs12 md6 class="toggle-position" align-self-center>
          <Toggle v-if="showYieldToggle"
            :theme="theme"
            :modelValue="plantYield"
            @toggleValueChange="(val) => plantYield = val">
            <v-btn flat value="energy">{{ $t('Energy') }}</v-btn>
            <v-btn flat value="yield">{{ $t('Yield') }}</v-btn>
          </Toggle>
        </v-flex>
      </v-layout>
      <div class="graph">
        <component :is="selectedComponent" :blockLevel="isBlockLevel" :graph="graphCategory"
          :date="fullDate" :type="graphType" :blockId="blockIdSelected"
          :invRoom="selectedInvRoom" :plantYield="plantYield" :isMultipleDays="isMultipleDays">
        </component>
      </div>
    </v-container>
  </Card>
</template>

<script>
import { mapGetters } from 'vuex'
import { EventBus } from '@/services/event-bus'
import { mixin, mapGettersMixin } from '@/util/mixin/index'
const plantGeneration = () => import('@/components/dashboard-inverter/PlantGeneration')
const plantPower = () => import('@/components/dashboard-inverter/PlantPower')
const plantEnergy = () => import('@/components/dashboard-inverter/PlantEnergy')
const Toolbar = () => import('@/components/common/Toolbar')
const moment = require('moment')

export default {
  components: {
    plantGeneration,
    plantPower,
    plantEnergy,
    Toolbar
  },
  props: ['fullDate', 'blockList','totalGen'],
  mixins: [mixin, mapGettersMixin],
  data() {
    return {
      blockIdSelected: null,
      selectedInvRoom: null,
      isBlockLevel: true,
      plantYield: 'energy',
      selectedComponent: 'plantEnergy',
      graphCategory: 'Energy',
      graphType: 'Total',
      isMultipleDays: false,
      windowWidth: window.innerWidth,
      totalInvGen: 0
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  computed: {
    ...mapGetters(['getSelectedPlantId']),
    showDate() {
      return `${moment(this.fullDate[0]).format('YYYY/M/D')} - ${moment(
        this.fullDate[1]
      ).format('YYYY/M/D')}`
    },
    graphName() {
      return this.graphCategory === 'Energy'
        ? 'Generation Graph'
        : `${this.graphCategory} Graph`
    },
    showYieldToggle() {
      return (
        this.isMultipleDays &&
        this.graphCategory === 'Energy' &&
        !this.isBlockLevel
      )
    },
    showGraphType() {
      return !this.isBlockLevel && this.graphCategory !== 'Plant Total'
    },
    graphCategoryList() {
      return [
        {
          text: this.$t('Plant Total'),
          value: 'Plant Total'
        },
        {
          text: this.$t('Energy'),
          value: 'Energy'
        },
        {
          text: this.$t('Power'),
          value: 'Power'
        }
      ]
    },
    graphTypeList() {
      return [{
        text: this.$t('Total'),
        value: 'Total'
      }, {
        text: this.$t('Inverter Wise'),
        value: 'Inverter Wise'
      }]
    },
    isLargeScreen() {
      return this.windowWidth < 960;
    },
  },
  created() {
    EventBus.$on('change:level', this.levelChanged)
  },
  beforeDestroy() {
    EventBus.$off('change:level', this.levelChanged)
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    levelChanged(payload) {
      // TODO: MARK CHANGED
      this.isBlockLevel = payload.level === 'block'
      if (payload.level === 'room') {
        this.blockIdSelected = payload.id.split('-')[0]
        this.selectedInvRoom = payload.id.split('-')[1]
      } else {
        this.blockIdSelected = payload.id
        this.selectedInvRoom = null
      }
    },
    graphChangeHandler(graph) {
      this.graphCategory = graph
      switch (graph.toLowerCase()) {
        case 'energy':
          this.selectedComponent = plantEnergy
          break
        case 'power':
          this.selectedComponent = plantPower
          break
        default:
          this.selectedComponent = plantGeneration
          break
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    blockDataHandler(selectedBlockId) {
      this.blockIdSelected = selectedBlockId;
    },
  },
  watch: {
    getSelectedPlantId() {
      this.graphCategory = 'Energy'
      this.graphType = 'Total'
    },
    totalGen(newValue) {
      this.totalInvGen = newValue;
    },
    fullDate() {
      if (
        this.dateValidate(this.fullDate[0]) &&
        this.dateValidate(this.fullDate[1])
      ) {
        if (this.fullDate[0] === this.fullDate[1]) {
          this.isMultipleDays = false
        } else {
          this.isMultipleDays = true
        }
      } else {
        this.alertMessage = 'Please select a valid date'
        this.snackbar = true
      }
    }
  }
}
</script>

<style scoped>
  .graph {
    width: 100%;
    height: 520px;
  }
  .toggle-position {
    text-align: center;
  }
  .box-width {
    width: 180px;
  }
  .bg {
    background-color: #f5f5f5 !important;
    width: 100%;
  }
  .block {
    display: none;
  }

  @media (max-width:1880px) and (min-width:960px) {
    .align-left {
      margin-left: -20px !important;
    }
  }
  @media(max-width:1880px) and (min-width:510px) {
    .subheading {
      margin-left: -10px;
    }
  }
  @media (max-width:960px) and (min-width:910px) {
    .space {
      padding-left: 10px;
    }
  }

  @media (max-width:910px) {
    .block {
      display: block;
    }
    .graph {
      height: 100%;
      padding-bottom: 20px;
    }
    .space {
      margin-left: 7px;
      padding-left: 7px;
      margin-bottom: 3px !important;
    }
  }
  @media (max-width:960px) {
    .hide-select {
      display: none;
    }
  }
  @media (max-width:510px) {
    .layout {
      margin-left: 5px !important;
    }
  }
</style>
